import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "../lib/cn";
import { focusRing, hoverTransition } from "../lib/styles";

export interface TextareaProps
  extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "className"> {
  invalid?: boolean;
  className?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid = false, className, rows = 4, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid || undefined}
      className={cn(
        "min-h-20 w-full resize-y rounded-sm border bg-default px-2.5 py-2 text-sm text-default",
        "placeholder:text-placeholder disabled:cursor-not-allowed disabled:bg-subtle",
        invalid ? "border-danger" : "border-control",
        focusRing,
        hoverTransition,
        className,
      )}
      {...rest}
    />
  );
});
